// extracted by mini-css-extract-plugin
export default {"modalDialog":"kJywiaI2","passwordModalDialog":"FYtlcmCw","transactionBanner":"yYT_DSGe","operationInfoFee":"k75dvmdJ","operationInfoFeeWithGap":"F2nQ3VmO","unstakeInfo":"zw06OBVe"};